<div class="container">
    <h2>Re-Upload Files for Order #{{orderId}}</h2>

    <!-- Notes Section -->
    <div class="notes-section">
        <h3 class="notes-title">Please Note</h3>
        <ol class="notes-list">
            <li>We can only accept PDF of all documents. We cannot accept scanned images</li>
            <li>Septic, Swimming Pools, Oil tanks, and asbestos are outside the scope of this quote</li>
        </ol>
    </div>

    <!-- Loading Order Data -->
    <div *ngIf="isLoadingOrder" class="loading">
        <p>Loading order details...</p>
    </div>

    <!-- Order Not Found -->
    <div *ngIf="orderNotFound && !isLoadingOrder" class="error-message">
        <h3>Order Not Found</h3>
        <p>The order with ID {{orderId}} could not be found. Please check the order ID and try again.</p>
    </div>

    <!-- Main Content -->
    <div *ngIf="!isLoadingOrder && !orderNotFound && orderData">
        <!-- File Upload Form -->
        <form [formGroup]="uploadForm" (ngSubmit)="submitUploads()">
            <div class="file-upload-container">
                <!-- Changed from fileTypes to visibleFileTypes -->
                <div *ngFor="let fileType of visibleFileTypes" class="file-upload-row">
                    <!-- File type name -->
                    <div class="file-type-info">
                        <span class="file-type-name">{{fileType.name}}</span>
                    </div>

                    <!-- Existing file section - always present for consistent layout -->
                    <div class="existing-file">
                        <div class="existing-file-info" *ngIf="hasExistingFile(fileType.key)">
                            <span class="existing-file-name"
                                [title]="extractFileNameFromUrl_Public(getExistingFileUrl(fileType.key))">
                                📄 <span
                                    class="filename-text">{{extractFileNameFromUrl_Public(getExistingFileUrl(fileType.key))}}</span>
                            </span>
                            <button type="button" class="download-btn" (click)="downloadExistingFile(fileType.key)">
                                View
                            </button>
                        </div>
                    </div>

                    <!-- File input section -->
                    <div class="file-input-section">
                        <div class="file-input-row">
                            <div class="file-input-wrapper">
                                <input type="file" #fileInput class="file-input-hidden" [formControlName]="fileType.key"
                                    (change)="onFileSelected($event, fileType.key)" accept=".pdf,.jpg,.jpeg,.png"
                                    [disabled]="hasExistingFile(fileType.key) || isLoading">
                                <button type="button" class="file-input-button"
                                    [class.disabled]="hasExistingFile(fileType.key) || isLoading"
                                    [disabled]="hasExistingFile(fileType.key) || isLoading"
                                    (click)="triggerFileInput(fileInput)">
                                    Choose file
                                </button>
                            </div>
                            <div class="file-info-section">
                                <span class="file-input-name" [title]="getFileDisplayName(fileType.key)">
                                    {{getFileDisplayName(fileType.key)}}
                                </span>
                            </div>
                        </div>

                        <!-- Upload Result Display -->
                        <div *ngIf="uploadResults[fileType.key]" class="upload-result"
                            [ngClass]="{'success': uploadResults[fileType.key].success, 'error': !uploadResults[fileType.key].success}">
                            {{getUploadResultIcon(fileType.key)}}
                            {{uploadResults[fileType.key].message}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Upload Buttons -->
            <div class="action-buttons">
                <button type="submit" class="btn upload-btn" [disabled]="isLoading || filesToUpload.size === 0">
                    <span *ngIf="!isLoading">Upload Selected Files ({{filesToUpload.size}})</span>
                    <span *ngIf="isLoading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Uploading...
                    </span>
                </button>

                <button type="button" class="btn clear-btn" (click)="clearAllUploads()" [disabled]="isLoading">
                    Clear Selections
                </button>
            </div>
        </form>
    </div>
</div>